// extracted by mini-css-extract-plugin
module.exports = {"container":"loader_container__1Rx1R","loader":"loader_loader__2tHs8"};